export default
{
  message: 'hello i18n !!',
  app: {
    about: 'About E-cademy',
    register: 'Register',
  },
  home: {
    title: 'Welcome to E-cademy Music',
    contacts: 'Contacts',
  },
  menu: {
    teachers: 'Teachers',
    courses: 'Courses',
    'musical-instruments': 'Musical Instruments',
  },
  header: {
    login: 'Login',
    profile: 'My profile',
    messages: 'Messages',
    logout: 'Logout',
    menu: 'Menu',
  },
  login: {
    title: 'Have you already an account? Log in!',
    'title-register': 'New on E-cademy?',
    reset: 'Forgot your password?',
  },
  register: {
    title: 'New on E-cademy? Register now!',
    subtitle: 'Register as student',
    first: 'First Name',
    last: 'Last Name',
    confirm: 'Confirm Password',
    register: 'Register',
    lang: 'Language',
    login: 'Have you already an account?',
    masterclass: 'Register to be part of the E-cademy World!',
    'register-me': 'Register me now!',
    verify: 'Check your mailbox and verify your email!',
    asTeacher: 'To be registered as a teacher write to: ',
  },
  errors: {
    firstname: 'Firstname is required',
    lastname: 'Lastname is required',
    email: 'A valid email address is required',
    password: 'A password is required',
    confirm: 'A password confirmation is required',
    subject: 'Subject is required',
    message: 'Message body is required',
  },
  dashboard: {
    contact: 'Contact',
    book: 'Book lesson',
    calendar: 'Lessons calendar',
    complete: 'Complete your profile',
    teachers: 'Our Teachers',
    'profile-photo': 'Change profile picture',
  },
  admin: {
    title: "I'm the dashboard of ADMIN: ",
    subtitle: 'Register a new teacher',
  },
  teacher: {
    experience: 'Experience',
    lessons: 'Lessons held',
    students: 'Students followed',
    reviews: 'Reviews obtained',
    noReviews: 'No reviews yet',
    settings: 'Settings',
    classrooms: 'Classrooms',
    jobs: 'Work experiences',
    studies: 'Studies',
    instruments: 'Instruments',
    review: 'Reviews',
    yourReviews: 'Your reviews',
    info: 'Info',
    calendar: 'Calendar',
    tiers: 'Lessons',
    masterclasses: 'Masterclasses',
    payments: 'Payments',
  },
  student: {
    progress: 'Progress',
    lessons: 'Lessons followed',
    teachers: 'Teachers followed',
    data: 'Data',
    age: 'Age:',
    residence: 'Residence:',
    payments: 'Your payment methods',
    studies: 'Studies',
    instruments: 'Instruments',
  },
  messageForm: {
    from: 'from:',
    to: 'to:',
    subject: 'subject:',
    message: 'message:',
    send: 'Send',
    please: 'Please log in to send a message',
    sent: 'Sent message',
  },
  timezone: {
    title: 'In which default timezone would you like to see calendars and dates?',
    save: 'Save',
    change: 'Change',
    undo: 'Undo',
    local: 'Your local timezone:',
    default: 'Your default timezone:',
    useLocal: 'Set local as default',
    area: 'Choose geographic area',
    country: 'Choose reference city',
    seeLessons: "See lessons in teacher's timezone",
    comeBack: 'Come back to your timezone',
    timezone: 'Timezone',
    success: 'Timezone successfully updated',
    errorSelect: 'Please, select a timezone',
  },
  newTimezone: {
    title: 'You are in a different timezone than the one you have set',
    question: 'Which one do you want to use?',
    save: 'Save',
  },
  languageSwitcher: {
    label: 'language:',
  },
  lessonsPrices: {
    title: 'Your lessons prices',
    title_visitors: 'Lessons prices',
    subtitle: 'You can edit them later from your profile',
    currency: 'Currency:',
    single: 'Single lesson:',
    extra: 'Single lesson with extra (notes and sheet music):',
    package: 'Package of 10 lessons:',
    required: 'required fields',
    save: 'Save',
  },
  slotsCreation: {
    title: 'ENTER YOUR LESSONS TIME',
    days: 'DAY/S',
    from: 'from:',
    to: 'to:',
    lessonTime: 'Single lesson time:',
    breakTime: 'Break between consecutive lessons:',
    minutes: 'minutes',
    startHour: 'Start time',
    endHour: 'End time',
    startLunch: 'First break start time',
    endLunch: 'First break end time',
    startDinner: 'Second break start time',
    endDinner: 'Second break end time',
    secondBreak: 'Add a second break',
    save: 'Save',
    message: 'New lesson slots saved',
    button: 'Add new lessons',
    calendarTitle: 'Calendar',
    noLessons: 'You have not entered any lessons yet',
    back: 'Back',
    lunch: 'BREAK',
    warning: 'Warning! Some of your slots will not be inserted because they overlap with others that already exist.',
  },
  bookedLessonsDashboard: {
    title: 'Next booked lessons: ',
    title2: 'Next booked lessons as STUDENT: ',
    with: 'with',
    see: 'See all',
    reduce: 'Reduce',
    startLesson: 'START LESSON!',
  },
  bookingSlots: {
    title: 'Book This Lesson',
    subtitle: "You're booking a lesson on",
    from: 'from:',
    to: 'to:',
    cancel: 'Cancel',
    book: 'Book the lesson',
    sorry: 'Sorry, some slots have been booked from other users.',
    please: 'Please, reload the page.',
    noLessons: 'There are no upcoming lessons',
    booked: 'Lesson successfully booked!',
    notify: 'Notify ',
    lang: 'Choose the language for your lesson:',
    pack: 'Pack of',
    lessons: 'lessons',
    'lesson-tier': 'Choose the lesson tier',
    default: 'Use default payment method',
    'single-lesson': 'Single lesson',
    pending: 'Locked slot',
    student: 'Student',
    notComplete: 'has started booking the lesson but has not completed it yet.',
    free: 'Free the slot',
    cancellationDeadline: 'The free cancellation terms for this teacher are within ',
    hoursFromLesson: ' hours of the start of the lesson.',
    warning: 'Attention! This lesson starts in less than ',
    noFreeCancellation: ' hours, so it will not be possible to cancel the lesson for free and the payment will be charged',
    uncompleted: 'You have not completed the lesson booking!',
    complete: 'Complete booking',
    inAnHour: 'If the booking is not completed within one hour, the slot will be released',
    cannotBook: 'It is not possible to book this lesson because the teacher has not yet filled in her/his lesson settings.',
    comments: 'Write your needs / requests to the teacher (optional):',
  },
  editingSlots: {
    yourLesson: 'Your lesson',
    delete: 'Delete lesson',
    edit: 'Edit lesson',
    save: 'Save',
    areYouSure: 'Are you sure you want to delete the lesson?',
    success: 'Lesson updated successfully',
    warning: 'Warning! You are moving this lesson at the same time of another one',
    new: 'Select new lesson slot from your free slots',
    customize: 'Or customize',
  },
  review: {
    title: 'Leave a review of the lesson just ended',
    aboutTeacher: 'About the teacher',
    lessonTime: 'The teacher respected the lesson times.',
    clarifications: 'The teacher was available to provide clarifications and explanations.',
    interaction: 'The teacher interacted effectively and stimulates interest.',
    explanation: 'The teacher presented the arguments in a clear way.',
    aboutPlatform: 'About the platform',
    platformAdapted: 'The platform was adapted for the conduct of the lesson.',
    audioVideo: 'The audio-video quality was adequate.',
    comments: 'Comments and suggestions:',
    save: 'Save',
    savedReview: 'Review successfully saved',
    pleaseVoteTeacher: 'Please, give your teacher a vote',
    pleaseVotePlatform: 'Please, give the platform a vote',
  },
  notifications: {
    login: 'You are successfully logged in!',
    logout: 'You are no longer logged in!',
    credentialsInvalid: 'The given credentials are invalid.',
    errorTryAgain: 'There was an error. Please try again',
    expiredSession: 'Expired session. Please log in',
    errorReload: 'There was an error. Please reload the page',
    errorPayment: 'There was a payment error, please try again',
    voteTeacher: 'Please give a vote to your teacher',
    votePlatoform: 'Please give a vote to the platform',
    overlapDate: 'The entered date overlaps an existing slot',
    changedLessonSent: 'New lesson time proposal sent',
    answerSentToTeacher: 'Your answer has been sent to the teacher',
    none: 'Here you can see your notifications!',
  },
  payments: {
    stripe: 'Credit card',
    paypal: 'Paypal',
    sepa: 'SEPA',
    save: 'Save as default payment method',
    title: 'Payment',
    choose: 'Choose your payment method:',
    default: 'Your default payment method is:',
    change: 'Change',
    next: 'Next',
    auth: 'Authorize Payment',
    title2: 'At this point we only save the authorization to the payment, the withdrawal will be made when the free cancellation terms expire.',
    title3: '(If at the moment of the payment the authorization is expired, could be required again)',
    'booking-summary-lesson': 'You are booking a lesson on the',
    'booking-summary-price': 'at the price',
    success: 'Payment method successfully updated',
    authorized: 'Payment authorized',
    received: 'Payment received',
    gain: 'Gain of the month',
    receiveds: 'Received payments',
    noReceived: "You haven't received any payments yet.",
    lessons: 'Your lesson payments',
    noLessons: "You haven't completed any lessons yet.",
    authFailed: 'Your payment authorization has failed!',
    update: 'Update the payment method',
    failed: 'We are unable to proceed with this payment method',
    updateLesson: 'Update the payment method for this lesson',
  },
  stripe: {
    data: 'Payment data',
    holder: 'Card holder',
    save: 'Save',
    add: 'Add new card',
    enterPaymentMethod: 'Please enter a valid payment method',
    authRequired: 'Authentication required to authorize payment',
    expiry: 'Expiry:',
  },
  cards: {
    cards: 'My cards',
    areYouSure: 'Are you sure you want to delete this payment method?',
    irreversible: 'Irreversible operation',
    delete: 'Delete',
    cancel: 'Cancel',
    expired: 'EXPIRED!',
    last: 'your last payment method',
    seeAll: 'See all cards',
    close: 'Close',
  },
  sepa: {
    firstname: 'Firstname',
    lastname: 'Lastname',
    save: 'Save IBAN',
  },
  iban: {
    seeAll: 'See all iban',
    close: 'Close',
    add: 'Add new iban',
    save: 'Save iban',
  },
  masterclass: {
    price: 'Registration price',
    places: 'Available places',
    participate: 'Participate',
    registered: 'Registered:',
    'no-slides': 'No slides uploaded.',
    'load-slides': 'Upload slides',
    'change-slides': 'Change slides',
    start: "Let's start!",
    'is-started': 'The masterclass is started!',
    'subscribed-cl': 'The Masterclasses you subscribed',
    'no-masterclass': 'You are not subscibed to a masterclass yet!',
    started: 'To start discover our',
    seeMore: 'See more',
    from: 'from',
    to: 'to',
    registerNow: 'Register now to participate!',
    only: 'Only',
    placesStill: 'still available places!',
    subscribe: 'Subscribe!',
    alreadySubscribed: 'You are enrolled in the masterclass',
    withdraw: 'Withdraw your subscription',
    open: 'Open',
    title: 'E-cademy Masterclasses',
    unlimited: 'Unlimited places',
    add: 'Add new masterclass',
    addTitle: 'Title',
    description: 'Description',
    day: 'Day',
    max: 'Max participants',
    success: 'Masterclass successfully saved',
    enrolling: 'You are enrolling in the masterclass of',
    on: 'on',
    privacy: 'I consent to the processing of my data and I declare that I have read the privacy policy',
    newsletter: 'I agree to subscribe to the newsletter',
    signme: 'Sign me up!',
    successRegister: 'Registration was successful!',
    checkMail: 'Check your emails',
    pleaseAcceptPrivacy: 'Please accept the privacy policy.',
    pleaseComplete: 'Please complete the required data.',
    registerMe: 'Register me now!',
    edit: 'Edit',
    free: 'Free',
    unlimit: 'Unlimited',
    program: 'Program',
  },
  messages: {
    received: 'Received',
    sent: 'Sent',
    message: 'Messages',
    'none-sent': "You don't have any sent message.",
    'none-received': "You don't have received messages yet.",
    answer: 'Answer',
    read: 'Mark as read',
    unread: 'Mark as unread',
    forward: 'Forward',
  },
  lesson: {
    classrooms: 'Your Classrooms',
    classroom: 'Your Classroom',
    'no-class': 'You are not in any classroom yet!',
    discover: "To start discover our Academy's",
    teachers: 'teachers',
    start: 'and book a lesson!',
    with: 'Classroom with',
    next: 'Next lesson',
    download: 'Download all media',
    back: 'Go back to Classrooms',
    booked: 'Booked Lessons',
    past: 'Past Lessons',
    teacher: 'Teacher',
    payment: 'Payment received',
    'payment-pending': 'Pending Payment',
    'payment-method': 'Payment method:',
    'change-payment': 'Change payment method',
    'start-lesson': 'Start lesson!',
    'review-score': 'Your review score:',
    review: 'Leave a feedback!',
    lang: 'Language',
    participant: 'Participant',
    original: 'Original time',
    newProposed: 'New proposed time',
    newAsked: 'New time you proposed',
    reject: 'Reject new lesson time',
    accept: 'Accept new lesson time',
    lessonWith: 'Lesson with',
    goClassrooms: 'Go to classrooms',
    needChange: 'Need to change lesson time?',
    contact: 'Contact',
    startLesson: 'Start lesson!',
    reviewScore: 'Student review score',
    noReviews: 'No reviews',
    success: 'Lesson booked successfully',
    comments: 'Message from student:',
    yourComments: 'Your message:',
    areYouSure: 'Are you sure you want to cancel this lesson?',
    irreversible: 'Irreversible operation',
    terms: 'As the free cancellation terms have expired, payment will be charged.',
    cancelLesson: 'Cancel lesson',
    freeCancelLesson: 'Cancel lesson for free',
    cancel: 'Cancel',
    canceled: 'Canceled',
    cancelMessage: 'Leave a message to the teacher to let him know why',
    cancelSuccess: 'Lesson canceled successfully',
  },
  skills: {
    complete: 'Additional information',
    years: 'Years',
    year: 'Graduation year',
    'attended-year': 'Year of graduation',
    'attendance-years': 'Years of practice',
    'teaching-years': 'Years of teaching',
    course: 'Course',
    qualifications: 'Qualification',
    'personal-information': 'Personal Information',
    studies: 'Studies',
    'school-name': 'School name',
    city: 'City',
    province: 'Province',
    'course-attended': 'Course attended',
    title: 'Degree obtained',
    add: 'Add School / Course',
    save: 'Save school',
    'add-school': 'Add School',
    'new-school': "Sorry, we don't know you school, do you want to add it?",
    instruments: 'Instruments',
    instrument: 'How you describe your connection with the instrument?',
    'practise-years': 'Years of practice',
    why: 'What new things would you like to learn about it?',
    for: '(for help teachers to understand your level)',
    'add-instrument': 'Add Instrument',
    'new-instrument': 'Sorry, this instrument is not in the list, do you want to add a new one?',
    'instr-name': 'Instrument name',
    nation: 'Country',
    teach: 'Instruments to teach',
    'teach-method': "How do you describe your instrument's teaching method?",
    students: 'Which students are you targeting?',
    'work-experience': 'Work experience',
    company: 'Company name',
    role: 'Role Held',
    'start-year': 'Starting Year',
    'end-year': 'Ending Year',
    still: 'Still working',
    description: 'Description of your Working Experience',
    'add-experience': 'Add Experience',
    'save-exp': 'Save work experience',
    'sorry-work': "Sorry, we don't know your company, do you want to add it?",
    'add-company': 'Add company',
    firstname: 'Firstname',
    lastname: 'Lastname',
    address: 'Address',
    postcode: 'Postcode',
    state: 'State',
    country: 'Country',
    phone: 'Phone',
    age: 'Age',
    email: 'Email',
    professionalTitle: 'Professional Title (will be visible under your name)',
    educationalTitle: 'Educational Qualification',
    success: 'Data successfully updated',
    bio: 'Bio',
    now: 'now',
  },
  classrooms: {
    classrooms: 'Classrooms',
  },
  media: {
    media: 'Media',
    title: 'Your media',
    formats: 'The accepted formats are .pdf, .jpg, .png, .mov',
    size: 'Maximum file size: 6 MB',
    upload: 'Upload Media',
    delete: 'Are you sure to delete the media ',
    cannotDelete: 'You cannot delete this media because it is linked at templates.',
    available: 'Available media',
    selected: 'Selected media',
  },
  template: {
    template: 'Template',
    templates: 'Templates',
    title: 'Your templates',
    delete: 'Are you sure to delete the template ',
    cannotDelete: 'You cannot delete this template because it has tiers.',
    new: 'New',
    newTemplate: 'New template',
    description: 'Description',
    save: 'Save and add media',
  },
  tiers: {
    tiers: 'Tiers',
    title: 'Your tiers',
    book: 'Book a lesson with this teacher',
  },
  settings: {
    title: 'Booking deadline',
    deadline: 'Select the deadline for booking your lessons.',
    deleted: "Slots that won't be booked within that margin will be automatically deleted.",
    hours: 'hours',
    week: 'A week',
    languages: 'Languages',
    setLanguages: 'Select the languages in which you are available to teach:',
    save: 'Save',
    cancel: 'Cancellation deadline',
    selectDeadline: 'Select the deadline for the free cancellation of your lessons.',
    payment: "Lessons that won't be cancel within that margin will be paid by students even if they do not show up for class.",
    other: 'Other (in hours)',
  },
  tier: {
    edit: 'Edit Tier',
    name: 'Lesson Name',
    description: 'Lesson description',
    price: 'Price per hour',
    number: 'Lesson number',
    choose: 'Choose',
    icon: 'icon',
    color: 'color',
    add: 'Add',
    delete: 'Are you sure to delete the tier ',
    new: 'New tier',
    save: 'Save',
  },
  upload: {
    upload: 'Upload',
    select: 'Select a file',
    drag: 'Drag here your file (only ',
    or: 'or',
    notPdf: 'is not a pdf.',
    slideSuccess: 'Slide successfully uploaded',
    selectImage: 'Select an image',
    dragImage: 'Drag here your image',
    notImage: 'is not an image',
    imgSuccess: 'Image successfully uploaded',
    notFormat: 'is not in the right format.',
    chooseType: 'Choose your media type',
    image: 'Image',
    video: 'Video',
    pdf: 'Pdf',
    audio: 'Audio',
  },
  password: {
    accessData: 'Access data',
    changePassword: 'Change password',
    old: 'Old password',
    new: 'New password',
    newConfirm: 'Confirm new password',
    savePassword: 'Save new password',
  },
  'fill-in': 'Fill in this field',
};
